import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
//import { routerReducer, routerMiddleware } from 'react-router-redux';
import rootReducer from '../reducers'

//import * as Counter from './Counter';
//import * as WeatherForecasts from './WeatherForecasts';

//export default function configureStore (history, initialState) {
  
export default function configureStore (initialState = {}) {  
  
  // const reducers = {
  //   counter: Counter.reducer,
  //   weatherForecasts: WeatherForecasts.reducer
  // };

  const middleware = [
    thunk
    //routerMiddleware(history)
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }
  
  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
